export default "__VITE_ASSET__8PhQqDfp__"